import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-full w-full bg-google-maps-fallback bg-cover bg-center" }
const _hoisted_2 = { class: "h-full w-full backdrop-blur-sm backdrop-brightness-50" }
const _hoisted_3 = { class: "container lg:rize-grid flex h-full w-full items-center lg:items-center" }
const _hoisted_4 = { class: "w-full bg-black px-14 py-10 text-white lg:col-span-2 lg:col-start-2" }
const _hoisted_5 = { class: "mb-8 mt-4" }
const _hoisted_6 = { class: "ml-2 h-5 w-14 shrink-0" }

import { ref, watch, onMounted, Ref } from 'vue';
import { GoogleMap, MarkerCluster, Marker } from 'vue3-google-map';
import services from '@/components/cookies/services';
import LzIcon from '@/components/base/LzIcon.vue';
import events from '@/events';
import style from './style';

interface Coordinates {
    lat: number;
    lng: number;
    icon?: string;
}
interface LzGoogleMapsProps {
    mapClasses?: string;
    consentTitle: string;
    consentDescription: string;
    consentButtonLabel: string;
    defaultMapMarkerIcon: string;
    markers: Array<Coordinates>;
    apiKey: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LzGoogleMaps',
  props: {
    mapClasses: {},
    consentTitle: {},
    consentDescription: {},
    consentButtonLabel: {},
    defaultMapMarkerIcon: {},
    markers: {},
    apiKey: {}
  },
  setup(__props: any) {

const props = __props;


const consent = ref(false);
const mapRef: Ref<InstanceType<typeof GoogleMap> | null> = ref(null);

watch(
    () => mapRef.value?.ready,
    ready => {
        if (ready) {
            if (props.markers.length === 1) {
                mapRef.value.map.setCenter({
                    lat: props.markers[0].lat,
                    lng: props.markers[0].lng
                });
            } else {
                const bounds = new mapRef.value.api.LatLngBounds();
                props.markers.forEach(value => {
                    bounds.extend({ lat: value.lat, lng: value.lng });
                });
                mapRef.value.map.fitBounds(bounds);
            }
        }
    }
);

onMounted(() => {
    window.addEventListener(`consent-${services.googleMaps}`, (e: Event) => {
        consent.value = !!(e as CustomEvent).detail.consent;
    });
});

function enableGoogleMaps() {
    events.$emit('enable-cookies', services.googleMaps);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (consent.value)
      ? (_openBlock(), _createBlock(_unref(GoogleMap), {
          key: 0,
          "api-key": _ctx.apiKey,
          styles: _unref(style),
          class: _normalizeClass(["h-full w-full", _ctx.mapClasses]),
          ref_key: "mapRef",
          ref: mapRef,
          zoom: 15
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MarkerCluster), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markers, (item, i) => {
                  return (_openBlock(), _createBlock(_unref(Marker), {
                    key: i,
                    options: {
                            position: { lat: item.lat, lng: item.lng },
                            icon: {
                                url: item.icon || _ctx.defaultMapMarkerIcon,
                                scaledSize: { width: 60, height: 60 }
                            }
                        }
                  }, null, 8, ["options"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["api-key", "styles", "class"]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.consentTitle), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.consentDescription), 1),
                  _createElementVNode("button", {
                    onClick: enableGoogleMaps,
                    class: "group inline-flex items-center justify-center whitespace-normal"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.consentButtonLabel), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(LzIcon, {
                        name: "arrow",
                        class: "h-6 w-12 stroke-white stroke-2 transition-all transition-transform group-hover:translate-x-2"
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
  ]))
}
}

})